/** `/local-content?slot=&scope=location:01J…` */
export interface LocalContentSearch {
  slot?: string
  scope?: string
}

const ID = /^[0-9A-Za-z]{1,64}$/

export function validateLocalContentSearch(s: Record<string, unknown>): LocalContentSearch {
  const slot = typeof s.slot === 'string' && ID.test(s.slot) ? s.slot : undefined
  const scope = typeof s.scope === 'string' && /^(location|display_group|display):[0-9A-Za-z]{1,64}$/.test(s.scope) ? s.scope : undefined
  return { ...(slot ? { slot } : {}), ...(slot && scope ? { scope } : {}) }
}
